import { FieldType } from '../../enums/fieldType';
import { LinkedIdType } from '../../enums/linkedIdType';

import { FieldApi } from '../api/fieldApi';

export class FieldData {
    type: FieldType;
    name: string;
    value: string;
    linkedId: LinkedIdType;

    constructor(response?: FieldApi) {
        if (response == null) {
            return;
        }
        this.type = response.type;
        this.name = response.name;
        this.value = response.value;
        this.linkedId = response.linkedId;
    }
}
